import gql from "graphql-tag"
import MediaRevisionFragment from "../fragment/MediaRevisionFragment"

export default gql`
  ${MediaRevisionFragment}
  mutation mediaUpgradePrepare($mediaId: String!, $sourceFileId: String!, $destinationProviderId: String!) {
    revision: mediaUpgradePrepare(mediaId: $mediaId, sourceFileId: $sourceFileId, destinationProviderId: $destinationProviderId) {
      ...MediaRevisionFragment
    }
  }
`
